
















































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { systemCodeApi, SystemCodeWithKey } from '@/api'
import { orderBy } from 'lodash'
import { InputCode } from '@/components/molecules/InputCode'
import { CODE_KEY } from '@/config'
import { SortOrder, UserDetailStateInfo } from '@/types'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    items: [
      {
        name: 'type',
        headerText: '連絡先区分',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '80',
    items: [
      {
        name: 'name',
        headerText: '連絡先',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserOtherContactsTableItem {
  id: number
  type: {
    input: string
    display: string
    errorMessage: string
  }
  name: {
    input: string
    errorMessage: string
  }
}

export const defaultUserOtherContactsTableItem = (): UserOtherContactsTableItem => ({
  id: 0,
  type: {
    input: '',
    display: '',
    errorMessage: ''
  },
  name: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    DataTable
  }
})
export default class UserOtherContactsTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserOtherContactsTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get sortedInputItems(): UserOtherContactsTableItem[] {
    if (this.sortName) {
      return orderBy<UserOtherContactsTableItem>(
        this.inputItems,
        (item: UserOtherContactsTableItem) => {
          switch (this.sortName) {
            case 'type':
              return item.type.display
            case 'name':
              return item.name.input
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get contactsInfoTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.CONTACTS_INFO_TYPE.KEY)
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.unshift(defaultUserOtherContactsTableItem())
  }

  remove(index: number): void {
    this.inputItems.splice(index, 1)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
